import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Renders a search suggestion with highlighted text matching the user's input.
export function AutocompleteItem({
  keyword,
  suggestion
}) {
  // If there's a keyword, highlight it
  if (keyword) {
    // Create a regex that captures the keyword but preserves spaces
    const regex = new RegExp(`(${keyword})`, 'gi');

    // Replace the keyword with a special marker that we can split on later
    // This preserves all spaces in the original text
    const markedText = suggestion.replace(regex, '§KEYWORD§$1§END§');

    // Split by our markers to separate matching and non-matching text segments
    const parts = markedText.split('§KEYWORD§');
    return /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: parts.map((part, index) => {
        // Check if this part contains our end marker
        if (part.includes('§END§')) {
          const [keywordPart, rest] = part.split('§END§');
          return /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx("strong", {
              children: keywordPart
            }), rest]
          }, index);
        }
        return /*#__PURE__*/_jsx("span", {
          children: part
        }, index);
      })
    });
  }

  // Default case: just show the suggestion as is
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    children: suggestion
  });
}